import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import uuid from "uuid/v4";
import { loadTokenLogin } from "@mochi/misc/auth/login/redux";
import { ILogin } from "@mochi/misc/interfaces";
import * as LoginSession from "@mochi/misc/auth/util/loginSession";
import { IPanadenState } from "../../@models/iPanadenState";
import { Dispatch } from "redux";
import { discardLoginUrlAction } from "../../private-route";
import { Grid, Typography, Button, FormControl, InputLabel } from "@material-ui/core";
import GoBack from "../../../features/common/layout/GoBack";
import { useStyles, BootstrapInput } from "../assets/styles";
import TitlePage from "../../common/layout/TitlePage";
import Progress from "./../../common/layout/Progress";
import {handleEnterSubmitForm} from '../../../utils/helpers';

export const Login = ({ history, login, authenticated, redirectUrl, discardLoginUrl, loginSuccess, loginState }) => {
  const classes = useStyles();
  const [password, setPassword] = useState("");
  const [loginFail, setLoginFail] = useState(false);
  const [firstLogin, setFirstLogin] = useState(true);
  const constructionID: any = localStorage.getItem("_data") || "{}";
  const { id } = JSON.parse(constructionID);

  useEffect(() => {
    if (authenticated && loginSuccess) {
      history.push(redirectUrl);
      discardLoginUrl();
    }

    if (loginSuccess === false) {
      setLoginFail(true)
    } else {
      setLoginFail(false)
    }
  }, [authenticated, discardLoginUrl, history, loginSuccess, redirectUrl]);

  const handleLogin = () => {
    login({
      mode: "MODE_CREATE_RESIDENT_LOGIN_TOKEN",
      param: {
        tenantId: { content: "1" },
        uuid: { content: uuid() },
        userId: { content: id },
        password: { content: password }
      }
    });
    setFirstLogin(false)
  };

  const handleTextFieldChange = (func: (value: string) => void) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = event.target;
    func(value);
  };

  return (
    <Fragment>
      <Progress status={loginState.status} />
      <TitlePage label="パスワード" />
      <Grid
        container
        item
        justify="center"
        alignItems="center"
        direction="column"
      >
        <Grid container justify="center" className={classes.goback}>
          <GoBack />
        </Grid>
        <Grid container item justify="center" className={classes.root}>
          <Grid container justify="center" className={classes.groupForm}>
            <form className={classes.form} onSubmit={handleEnterSubmitForm}>
              <FormControl className={classes.margin}>
                <InputLabel
                  shrink
                  htmlFor="bootstrap-input"
                  className={classes.inputLabel}
                >
                  パスワード
                </InputLabel>
                <BootstrapInput
                  fullWidth
                  placeholder=""
                  id="bootstrap-input"
                  type="password"
                  onChange={handleTextFieldChange(setPassword)}
                  value={password}
                  style={{ border: loginFail && !firstLogin ? '1px solid ##f55d5d' : '1px solid #ced4da', borderRadius: 6 }}
                />
                {loginFail && !firstLogin && (
                  <Typography
                    component="p"
                    color="error"
                    className={classes.notifiError}
                  >
                    パスワードが違います。
                  </Typography>
                )}

                <Button
                  disableRipple
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={handleLogin}
                >
                  <Typography className={classes.labelButton}>
                    ログイン
                  </Typography>
                </Button>
              </FormControl>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

const authenticate = (login: ILogin) =>
  !LoginSession.isExpired() && login.apiTokenSuccess && login.loginTokenSuccess;

const mapStateToProps = (state: IPanadenState) => ({
  authenticated: authenticate(state.login),
  loginSuccess: state.login.loginTokenSuccess,
  redirectUrl: "/register-room", //state.privateRoute && state.privateRoute.savedRequiredLoginUrl
  loginState: state.login
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  login: (data: any) => dispatch(loadTokenLogin(data)),
  discardLoginUrl: () => dispatch(discardLoginUrlAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
